/**
 * Play model
 * 
 * @class Model_Play
 * @extends Model
 */

Model_Play = (function (Model) {

    var Model_Play = function () {
        this.construct.apply(this, arguments);
    };

    $.extend(true, Model_Play.prototype, Model.prototype, {
		/**
		 * Construct object
		 * @constructor
		 */
        construct: function (attributes) {
            this.data = {};
            this.init();
            this.parseData(attributes);
        },

		/**
		 * Initialize Model_Play
		 */
        init: function () {
			/** 
			 * @property {Boolean} fetched - flag for fetching full asset detail and related assets.
			 * NOTE: it's set by Model_Play.fetchFullDetail
			 */
            this.fetched = false;
			
			/** 
			 * @property {Object} seasons - Associative array of seasons with episodes
			 * NOTE: it's filled by Model_Play.
			 */
            this.seasons = {};
			/** 
			 * @property {Collection} relatedColl - Collection of related assets
			 * NOTE: it's filled by Model_Play.fetchRelated
			 */

			/** 
			 * @property {Object} playingOptions - It keeps useful parameters for Player 
			 * NOTE: it's set by Model_Play.setPlayingOpt(...)
			 */
            this.playingOptions = null;
        },

        fetch: function() {
            return new Promise(function(resolve, reject) {
                resolve();
            })
        },

        parseData: function (data) {
            this.data = {};
            $.extend(true, this.data, data);
        },

		/**
		 * @returns {String} Model id
		 */
        getId: function () {
            return (this.data && this.data.id) ? this.data.id : false;
        },

		/**
		 * @returns {Boolean} return value tells if full asset detail and related assets were fetched
		 */
        isFetched: function () {
            return this.fetched;
        },
		/**
		 * @returns {Boolean} return value tells if asset has fully downloaded detail
		 */
        isFullDetailFetched: function () {
            return this.fullDetailFetched;
        },
		/**
		 * @returns {Boolean} status if current asset has related assets
		 */
        isRelatedFetched: function () {
            return this.relatedFetched;
        },

		/**
		 * @returns {Boolean} status if current asset has related assets
		 */
        hasRelated: function () {
            return !!this.relatedColl.length;
        },

		/**
		 * @returns {Collection} collection of related movies
		 */
        getRelated: function () {
            return this.relatedColl;
        },

        getRelatedId: function () {
            return this.data.relId;
        },

		/**
		 * @returns {String} Movie id
		 */
        getID: function () {
            return this.getId();
        },

		/**
		 * @returns {String} Movie title
		 */
        getTitle: function () {
            return this.data.name;
        },

        getYear: function() {
            var releaseDate = this.data.created_at;
            releaseDate = releaseDate ? releaseDate.substr(0, 4) : '';
            return releaseDate;
        },

		/**
		 * @returns {String} Movie description
		 */
        getDescription: function () {
            return this.data.description;
        },

		/**
		 * @returns {String} Movie description
		 */
       
		/**
		 * Get duration of video
		 * @returns {Number} duration of item
		 */
        getDuration: function () {
            if (this.data.videoDuration)
                return Math.round(this.data.videoDuration/60);
            else return 0;
        },

		/**
		 * Get directors
		 * @returns {Array} of strings
		 */
        getDirectors: function () {
            return this.data.directors || [];
        },

		/**
		 * Get actors
		 * @returns {Array} of strings
		 */
        getActors: function () {
            return this.data.actors || [];
        },

		/**
		 * To get URL of Main video specified by Audio
		 * @param {string} audio - audio track as ISO-639-3 code (e.g: "eng") (optional) if not then returns first MainVideoURL from List
		 * @returns {String} main video URL
		 */
        getMovieId: function (audio) {
            return this.getId();
        },

		/**
		 * To get URL of Main video specified by Audio
		 * @param {string} audio - audio track as ISO-639-3 code (e.g: "eng") (optional) if not then returns first MainVideoURL from List
		 * @returns {String} main video URL
		 */
        getMovieUrl: function (audio) {
            return Api.provider.getStream(this.getId());
        },

		/**
		 * Get the appropriate cover
		 * @param {String} type 'poster', 'hero', 'landscape', ...
		 * @returns {String} image URL, otherwise "blank"
		 */
        getImage: function (size) {
            switch (size) {
                case 'carousel':
                    if (this.data.hasOwnProperty('thumb_url')) {
                        return this.data.thumb_url;
                    }
                    break;
                case 'slider':
                    if (this.data.hasOwnProperty('thumb_url')) {
                        return this.data.thumb_url;
                    }
                    break;
                case 'detail-slider':
                    if (this.data.hasOwnProperty('thumb_url')) {
                        return this.data.thumb_url;
                    }
                    break
                default:
                    break;
            }
            return this.getEmptyCover(size || 'related');
        },

        getCarouselImage: function () {
            return CONFIG.imageResizerUrl + this.getImage('carousel') + '.large.jpg';
        },
        getSliderImage: function () {
            return CONFIG.imageResizerUrl + this.getImage('slider') + '.small.jpg';
        },
        getDetailSliderImage: function () {
            return CONFIG.imageResizerUrl + this.getImage('detail-slider') + '.small.jpg';
        },
        getGridImage: function () {
            return this.getImage('grid');
        },
        getEmptyCover: function (size) {
            return "./img/empty-" + size + ".png";
        }

    });

    return Model_Play;

})(Model);



//////////////////
// WEBPACK FOOTER
// ./js/model/play.js
// module id = 48
// module chunks = 0